import { getConfigBooleanValue } from "./configClient";

export const isListingMonetizationAEnabled = (defaultValue = false) => {
  return getConfigBooleanValue('ListingMonetizationCheckoutA', defaultValue);
}

export const isListingMonetizationBEnabled = (defaultValue = false) => {
  return getConfigBooleanValue('ListingMonetizationCheckoutB', defaultValue);
}
